module.exports = __webpack_public_path__ + "static/media/HTI.4254839b.svg";